import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot, NavigationExtras } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';
import { WindowRef } from '../services/window-ref.service';


@Injectable()
export class AuthGuard implements CanActivate {

  constructor(private router: Router,
    private authenticationService: AuthenticationService,
    private window: WindowRef) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    var path = null;
    if (this.window.nativeWindow.location.pathname != "/" && this.window.nativeWindow.location.pathname.length > 0) {
      path = this.window.nativeWindow.location.pathname.slice(1, this.window.nativeWindow.location.pathname.length);
    }
    return this.authenticationService.userLoggedIn(path);
  }
}
